export class Settings {
    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    public static readonly SymbolEmpty: number = -1;
    public static readonly SymbolCherry: number = 1;
    public static readonly SymbolLemon: number = 2;
    public static readonly SymbolOrange: number = 3;
    public static readonly SymbolPlum: number = 4;
    public static readonly SymbolGrapes: number = 5;
    public static readonly SymbolMelon: number = 6;
    public static readonly SymbolBell: number = 7;
    public static readonly SymbolSeven: number = 8;
    public static readonly SymbolDiamond: number = 9;
    public static readonly SymbolMystery: number = 10;
    public static readonly SymbolBigXSpins: number = 11;
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/Settings.ts
 **/